import { CommonModule } from '@angular/common';
import { Component, Input } from '@angular/core';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';

export interface AlreadyClonedProject {
  projectId: string;
  projectName: string;
  clientName: string;
}

@Component({
  selector: 'app-cloned-warning-modal',
  standalone: true,
  imports: [CommonModule],
  templateUrl: './cloned-warning-modal.component.html',
})
export class AlreadyClonedWarningModalComponent {
  @Input() projects: AlreadyClonedProject[] = [];

  constructor(public modal: NgbActiveModal) {}

  confirm(): void {
    this.modal.close(true);
  }
}